export default {
    gatewayAPI: require("./gatewayAPI"),
    userAPI: require("./userAPI")
};



/** WEBPACK FOOTER **
 ** ./app/sources/index.js
 **/